/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: k4MoYHGY6d3NVAoA3aDDg2

import * as React from "react";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: k4MoYHGY6d3NVAoA3aDDg2/projectModule
import { AntdConfigProvider } from "@plasmicpkgs/antd5/skinny/registerConfigProvider";
import { EmbedCss } from "@plasmicpkgs/plasmic-embed-css";
import { SupabaseActions } from "@/components/SupabaseActions"; // plasmic-import: IiRaEcu_fUus/codeComponent
import { PreferencesProvider } from "@/components/PreferencesProvider"; // plasmic-import: WsDAmTOQUKuk/codeComponent

export interface GlobalContextsProviderProps {
  children?: React.ReactElement;
  antdConfigProviderProps?: Partial<
    Omit<React.ComponentProps<typeof AntdConfigProvider>, "children">
  >;

  embedCssProps?: Partial<
    Omit<React.ComponentProps<typeof EmbedCss>, "children">
  >;

  supabaseActionsProps?: Partial<
    Omit<React.ComponentProps<typeof SupabaseActions>, "children">
  >;

  preferencesProviderProps?: Partial<
    Omit<React.ComponentProps<typeof PreferencesProvider>, "children">
  >;
}

export default function GlobalContextsProvider(
  props: GlobalContextsProviderProps
) {
  const {
    children,
    antdConfigProviderProps,
    embedCssProps,
    supabaseActionsProps,
    preferencesProviderProps
  } = props;

  return (
    <AntdConfigProvider
      {...antdConfigProviderProps}
      borderRadius={
        antdConfigProviderProps && "borderRadius" in antdConfigProviderProps
          ? antdConfigProviderProps.borderRadius!
          : 6
      }
      colorBgBase={
        antdConfigProviderProps && "colorBgBase" in antdConfigProviderProps
          ? antdConfigProviderProps.colorBgBase!
          : "#ffffff"
      }
      colorError={
        antdConfigProviderProps && "colorError" in antdConfigProviderProps
          ? antdConfigProviderProps.colorError!
          : "#ff4d4f"
      }
      colorInfo={
        antdConfigProviderProps && "colorInfo" in antdConfigProviderProps
          ? antdConfigProviderProps.colorInfo!
          : "#1677ff"
      }
      colorPrimary={
        antdConfigProviderProps && "colorPrimary" in antdConfigProviderProps
          ? antdConfigProviderProps.colorPrimary!
          : "#327CE4"
      }
      colorSuccess={
        antdConfigProviderProps && "colorSuccess" in antdConfigProviderProps
          ? antdConfigProviderProps.colorSuccess!
          : "#52c41a"
      }
      colorWarning={
        antdConfigProviderProps && "colorWarning" in antdConfigProviderProps
          ? antdConfigProviderProps.colorWarning!
          : "#faad14"
      }
      controlHeight={
        antdConfigProviderProps && "controlHeight" in antdConfigProviderProps
          ? antdConfigProviderProps.controlHeight!
          : 32
      }
      defaultDark={
        antdConfigProviderProps && "defaultDark" in antdConfigProviderProps
          ? antdConfigProviderProps.defaultDark!
          : false
      }
      lineWidth={
        antdConfigProviderProps && "lineWidth" in antdConfigProviderProps
          ? antdConfigProviderProps.lineWidth!
          : 1
      }
      loadingText={
        antdConfigProviderProps && "loadingText" in antdConfigProviderProps
          ? antdConfigProviderProps.loadingText!
          : undefined
      }
      removeLoading={
        antdConfigProviderProps && "removeLoading" in antdConfigProviderProps
          ? antdConfigProviderProps.removeLoading!
          : undefined
      }
      sizeStep={
        antdConfigProviderProps && "sizeStep" in antdConfigProviderProps
          ? antdConfigProviderProps.sizeStep!
          : 4
      }
      sizeUnit={
        antdConfigProviderProps && "sizeUnit" in antdConfigProviderProps
          ? antdConfigProviderProps.sizeUnit!
          : 4
      }
      themeStyles={
        antdConfigProviderProps && "themeStyles" in antdConfigProviderProps
          ? antdConfigProviderProps.themeStyles!
          : true
            ? {
                fontFamily: "Inter",
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "1.5",
                color: "#535353",
                letterSpacing: "normal"
              }
            : undefined
      }
      wireframe={
        antdConfigProviderProps && "wireframe" in antdConfigProviderProps
          ? antdConfigProviderProps.wireframe!
          : false
      }
    >
      <EmbedCss
        {...embedCssProps}
        css={
          embedCssProps && "css" in embedCssProps
            ? embedCssProps.css!
            : "@keyframes pulse {\r\n  0% { opacity: 1; }\r\n  25% { opacity: 1; }\r\n  50% { opacity: .7; }\r\n  75% { opacity: 1; }\r\n  100% { opacity: 1; }\r\n}\r\n@keyframes warning-flash {\r\n  0% {\r\n    border-color: red;\r\n  }\r\n  50% {\r\n    border-color: transparent;\r\n  }\r\n  100% {\r\n    border-color: red;\r\n  }\r\n\r\n}\r\n@keyframes police-flash {\r\n  0% {\r\n    border-color: red;\r\n  }\r\n  25% {\r\n    border-color: transparent;\r\n  }\r\n  50% {\r\n    border-color: blue;\r\n  }\r\n  75% {\r\n    border-color: transparent;\r\n  }\r\n  100% {\r\n    border-color: red;\r\n  }\r\n}\r\n\r\n.ant-menu-item-selected {\r\n  background-color: rgba(0, 0, 0, 0.3) !important\r\n}\r\n\r\n.ant-menu-submenu-title, .ant-menu-submenu .ant-menu-title-content  {\r\n  color: rgba(255, 255, 255, 0.7) !important\r\n}\r\n.ant-menu-submenu-popup .ant-menu-title-content a {\r\n  color: #535353 !important\r\n}\r\n\r\n.jodit-status-bar {\r\n  display: none !important;\r\n}\r\n\r\n.jodit-toolbar__box {\r\n  display: none !important;\r\n}\r\n@media print {\r\n  body {\r\n    visibility: hidden;\r\n  }\r\n  #section-to-print {\r\n    visibility: visible;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@page {\r\n  size: auto;\r\n  margin: 0mm;\r\n}\r\n.ant-table-content {\r\n  \r\n overflow: visible !important;\r\n line-height: 2;\r\n\r\n\r\n \r\n  table {\r\n  color: rgb(40, 40, 40) !important;}\r\n\r\n  .ant-table-tbody td {\r\n\r\n  padding-top: 0px !important; \r\n  padding-bottom: 0px !important;}\r\n\r\n .ant-table-column-sorter {\r\n  display: none;}\r\n  .ant-table-column-has-sorters,span {\r\n   padding-top: 0px !important; \r\n  padding-bottom: 0px !important;\r\n  font-weight: bold;\r\n  color: black;\r\n  }\r\n  \r\n\r\n}\r\n\r\n\r\n\r\n\r\n.ant-table-tbody {\r\n\r\ntr:nth-child(2n) td {\r\n    background-color: #fbfbfb;}\r\n    \r\n}\r\n.ant-table-tbody thead {\r\n    background-color: #f1f1f1;\r\n\r\n\r\n}\r\n\r\n.react-flow__node {\r\n  width: 80px ;\r\n  height: 80px ;\r\n  \r\n  /* Optional: Center the label text inside the new square shape */\r\n  display: flex ;\r\n  justify-content: center ;\r\n  align-items: center ;\r\n  text-align: center;\r\n}\r\n\r\n.react-flow__attribution {\r\n  display: none !important;\r\n}\r\n\r\n"
        }
      >
        <SupabaseActions {...supabaseActionsProps}>
          <PreferencesProvider {...preferencesProviderProps}>
            {children}
          </PreferencesProvider>
        </SupabaseActions>
      </EmbedCss>
    </AntdConfigProvider>
  );
}
